import React, {ReactElement} from 'react';
import {Props} from './Props';
import DateTimeFormatted from '../../../../../../components/DateTimeFormatted';
import {roundToNearest} from '../../../../../../utils/RoundingUtil';

class DialogFcd extends React.Component<Props> {
    render(): ReactElement {
        const {properties, state, showRecordIds} = this.props;

        return (
            <>
                <table>
                    <tbody>
                        {showRecordIds && (
                            <tr>
                                <th>ID</th>
                                <td>{properties.linkId}</td>
                            </tr>
                        )}
                        <tr>
                            <th>Segmentlengte in meters</th>
                            <td>{roundToNearest(properties.lengthMm / 1000)}</td>
                        </tr>
                        <tr>
                            <th>Gemeten snelheid</th>
                            <td>{roundToNearest(state.avgSpeedKph)}</td>
                        </tr>
                        <tr>
                            <th>Vertraging in seconden</th>
                            <td>{roundToNearest(state.delayMs / 1000)}</td>
                        </tr>
                        <tr>
                            <th>Freeflow snelheid</th>
                            <td>{state.freeflowSpeedKph}</td>
                        </tr>
                        <tr>
                            <th>Tijdstip waarneming</th>
                            <td>
                                <DateTimeFormatted dateTime={new Date(state.measuredAtMs).toString()} />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </>
        );
    }
}

export default DialogFcd;
